<template>
  <div class="loginPage simpleRegistrationPage">
    <div class="logo">
      <!--91x92-->
      <van-image width="2.4267rem" height="2.4533rem" :src="logo" />
    </div>
    <van-field
      class="items tel"
      v-model="tel"
      type="tel"
      clearable
      placeholder="请填写手机号"
      :border="input_border"
    />
    <van-field
      class="items code-item"
      v-model="code"
      clearable
      type="digit"
      placeholder="输入验证码"
      :border="input_border"
    >
      <template #button>
        <div class="count-down-box">
          <van-count-down
            ref="countDown"
            :auto-start="false"
            @finish="countFinished"
            :time="time"
            format="ss"
            v-show="isOn"
            class="i-text"
          />
        </div>
        <van-button
          v-show="!isOn"
          size="small"
          @click="showSlider"
          color="#4993FA"
          >获取短信验证码</van-button
        >
      </template>
    </van-field>
    <van-button
      type="default"
      round
      size="large"
      class="btn firstTime"
      :loading="login_loading"
      loading-text="正在提交..."
      @click="onClickButtonSubmit"
      >下一步</van-button
    >
    <div class="privacy">
      <van-checkbox
        v-model="isSelected"
        icon-size="12px"
        style="font-size:13px"
        label-disabled
        >已阅读并同意
        <router-link style="color: #c0c8ff;font-size:13px" to="/privacy"
          >《{{ platformName }}隐私政策》</router-link
        >
      </van-checkbox>
    </div>
    <van-dialog
      v-model="showSliderFlag"
      :width="bjWidth + 30"
      :close-on-click-overlay="true"
      class="showSliderDialog"
      :show-confirm-button="false"
      title=""
    >
      <captha
        ref="captha"
        :fresh="fresh"
        :imgUrl="imgSrc"
        :miniImgUrl="miniImgUrl"
        :blocky="blocky"
        :w="bjWidth"
        :h="bjHeight"
        :sw="sWidth"
        :sh="shHeight"
        @refresh="reImg"
        @verify="verify"
      />
    </van-dialog>
  </div>
</template>
<script>
import {
  Image,
  Button,
  Field,
  Toast,
  Icon,
  Checkbox,
  Dialog,
  CountDown,
} from 'vant'
import { Notify } from 'vant'
import { getRandomVerifyImage, verifyRandomImage } from '@/api/ecompany/request'
import api from '@/api/list'
import { toSuitAblePageByEmp } from '@/api/employee/request'
import captha from '@/components/captha.vue'
import { setSimpleToken, getCompanyCodeHeaderKey } from '@/utils/auth'
import jwt_decode from 'jwt-decode'
export default {
  components: {
    [Image.name]: Image,
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Notify.name]: Notify,
    [Checkbox.name]: Checkbox,
    [CountDown.name]: CountDown,
    [Dialog.name]: Dialog,
    [Dialog.Component.name]: Dialog.Component,
    captha,
  },
  watch: {
    tel: {
      handler: function() {
        localStorage.setItem('this.tel', JSON.stringify(this.tel))
      },
    },
  },
  data() {
    return {
      time: 60 * 1000, //60秒
      bjWidth: 300,
      bjHeight: 150,
      sWidth: 60,
      shHeight: 60,
      proportion: 1, //在大屏 如ipd 上需要放大
      isOn: false,
      fresh: false,
      showSliderFlag: false, //显示滑块
      verifyImageId: '',
      miniImgUrl: '', //抠图图片地址
      imgSrc: '', //大图背景地址
      blocky: 0,
      isSelected: false,
      iconPath: process.env.VUE_APP_FILE_PATH,
      input_border: false,
      logo: require('@/assets/logo.png'),
      tel: '',
      code: '',
      login_loading: false,
      param: {},
      platformName: '工蚁宝',
    }
  },
  created() {
    this.init()
    this.getPageData()
    this.adaptationModel()
  },
  methods: {
    countFinished() {
      this.isOn = false
      this.$refs.countDown.reset()
    },
    //适配不同的机型
    adaptationModel() {
      if (window.screen.width >= 1000) {
        this.bjWidth = 600
        this.bjHeight = 300
        this.sWidth = 120
        this.shHeight = 120
        this.proportion = 2
      }
      if (window.screen.width >= 800 && window.screen.width < 1000) {
        this.bjWidth = 450
        this.bjHeight = 225
        this.sWidth = 90
        this.shHeight = 90
        this.proportion = 1.5
      }
    },
    //点击刷新
    reImg() {
      this.getPicture()
    },
    //去认证
    verify(left) {
      this.verifyRandomImages(left)
    },
    //点击获取二维码
    showSlider() {
      if (this.tel === '' || this.tel === undefined) {
        this.$toast('手机号不能为空')
        return false
      }
      if (this.tel.length !== 11) {
        this.$toast('请输入正确的手机号')
        return false
      }
      this.showSliderFlag = true
      this.$nextTick(function() {
        this.getPicture()
      })
    },
    init() {
      let companyCodeHeader = getCompanyCodeHeaderKey() // 从响应头中读取
      let ecompanyCode = this.$store.getters.ecompanyCode //this.$route.query.ecompanyCode;
      if (
        (ecompanyCode == null || ecompanyCode == '') &&
        companyCodeHeader != null &&
        companyCodeHeader != 'null'
      ) {
        // 定制化企业将企业编码配置在请求头中
        ecompanyCode = companyCodeHeader
      }

      if (ecompanyCode) {
        this.platformName = '灵工平台'
        this.param.ecompanyCode = ecompanyCode
      }
    },
    //获取验证码
    getCode() {
      this.param.mobile = this.tel
      api
        .easyRegisterSendSms(this.param)
        .then((res) => {
          if (res.data.status == '200') {
            this.showSliderFlag = false
            this.token = res.data.data
            this.isOn = true
            this.$refs.countDown.start()
            this.$toast('验证码已发送')
          } else {
            this.$toast(res.data.message)
          }
        })
        .catch((error) => {
          this.$toast(error.response.data.message)
          this.loading = false
        })
    },
    getPageData() {
      this.tel = JSON.parse(localStorage.getItem('this.tel')) //使用getItem方法的前提是，你再自己需要的地方使用了setItem方法
    },
    //验证滑块是否成功
    verifyRandomImages(w) {
      let that = this
      let formdata = new FormData()
      formdata.append('verifyImageId', this.verifyImageId)
      formdata.append('mobile', this.tel)
      formdata.append('xWidth', w * this.proportion)
      verifyRandomImage(formdata).then((res) => {
        let result = res.data
        if (result.status == 200) {
          //验证成功
          that.$refs.captha.handleSuccess()
          let c2 = setTimeout(function() {
            clearTimeout(c2)
            that.getCode()
          }, 100)
        } else {
          //验证失败
          that.$refs.captha.handleFail()
        }
      })
    },
    getPicture() {
      let that = this
      getRandomVerifyImage({ mobile: this.tel }).then((res) => {
        let result = res.data
        if (result.status == 200) {
          that.imgSrc = result.data.backImage
          that.miniImgUrl = result.data.slidingImage
          that.blocky = result.data.yHeight * this.proportion
          that.verifyImageId = result.data.verifyImageId
          let ctime = setTimeout(function() {
            clearTimeout(ctime)
            that.$refs.captha.reset()
          }, 0)
        }
      })
    },
    onClickButtonSubmit() {
      if (!this.isSelected) {
        this.$toast('请勾选协议!')
        return false
      }
      if (this.tel == '') {
        this.$toast('手机号码不能为空')
        return false
      }
      if (this.code == '') {
        this.$toast('验证码不能为空')
        return false
      }
      if (this.token == null || this.token == '' || this.token == undefined) {
        this.token = '12c4defa4f854f66bef10fa96c074b9f'
      }
      let parm = {
        tel: this.tel,
        code: this.code,
        type: 'easy_register',
        token: this.token,
      }
      let temp = JSON.parse(JSON.stringify(parm))
      ;(this.login_loading = true),
        this.$store
          .dispatch('Login', temp)
          .then((res) => {
            if (res.status == '200') {
              let param = {
                userName: this.tel,
                taskId: decodeURIComponent(this.$route.query.taskId),
              }
              setSimpleToken(res.data.simpleToken)
              this.$store.commit('SET_SIMPLE_TOKEN', res.data.simpleToken)

              toSuitAblePageByEmp(param)
                .then((resq) => {
                  let result = resq.data
                  if (result.status == '200') {
                    let direct = result.data.routerPath
                    let parm = {
                      path: direct,
                      query: {
                        username: this.tel,
                        taskId: this.$route.query.taskId,
                      },
                    }
                    if (
                      result.data.token &&
                      result.data.token != null &&
                      result.data.token != undefined &&
                      result.data.token != ''
                    ) {
                      parm.query.token = result.data.token
                    }
                    if (
                      result.data.id &&
                      result.data.id != null &&
                      result.data.id != undefined &&
                      result.data.id != ''
                    ) {
                      parm.query.id = result.data.id
                    }
                    if (
                      result.data.obj &&
                      result.data.obj != null &&
                      result.data.obj != undefined &&
                      result.data.obj != ''
                    ) {
                      parm.query.obj = result.data.obj
                    }
                    if (
                      result.data.backPath &&
                      result.data.backPath != null &&
                      result.data.backPath != undefined &&
                      result.data.backPath != '' &&
                      result.data.frontPath &&
                      result.data.frontPath != null &&
                      result.data.frontPath != undefined &&
                      result.data.frontPath != ''
                    ) {
                      parm.query.back = result.data.backPath
                      parm.query.front = result.data.frontPath
                    }

                    this.$router.push(parm)
                  } else {
                    this.$toast(result.message)
                  }
                })
                .catch(() => {})
            } else {
              this.$toast(res.message)
            }
            this.login_loading = false
          })
          .catch(() => {
            this.login_loading = false
          })
    },
  },
  mounted: function() {
    document.getElementsByTagName('body')[0].className = 'login_bg'
  },
  beforeDestroy: function() {
    document.body.removeAttribute('class', 'login_bg')
  },
}
</script>
<style lang="less">
.loginPage .privacy {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 0.42rem;
}
.loginPage .privacy .van-checkbox__icon .van-icon {
  border: 0.02667rem solid #fff;
}
.loginPage .privacy span.van-checkbox__label {
  color: #ffffff;
}
.simpleRegistrationPage .items {
  height: 50px;
}
.simpleRegistrationPage .items.tel {
  margin-bottom: 12px;
}
.simpleRegistrationPage .items .van-field__body {
  height: 100%;
}
.simpleRegistrationPage .items .van-field__control {
  height: 100%;
}
</style>
<style lang="less" scoped>
.count-down-box {
  color: white;
  background: rgb(73, 147, 250);
  border-color: rgb(73, 147, 250);
  height: 100%;
  width: 60px;
  border-radius: 2px;
  text-align: center;
  /deep/.van-count-down {
    color: #fff;
  }
}
.loginPage {
  display: block;
  padding: 20px 44px;

  .fixedLink {
    position: absolute;
    right: 0;
    top: 10px;
    width: 80px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 40px;
  }

  .logo {
    display: block;
    width: 91px;
    margin: 0 auto 48px;
  }

  .links {
    overflow: hidden;
    a {
      font-size: 13px;
      color: #fff;

      &.left {
        float: left;
      }

      &.right {
        float: right;
      }
    }
  }

  .btn {
    margin-top: 60px;
    &.firstTime {
      background: #25bfff;
      border: 1px solid #25bfff;
      color: #fff;
    }
  }
}
</style>
<style lang="less">
.loginPage {
  .van-cell {
    margin-bottom: 10px;
    border-radius: 6px;
    padding: 11px 12px 11px 25px;
  }
  .code-item {
    .van-field__control {
      width: 40%;
      min-width: 2rem;
    }
    .van-field__button {
      position: absolute;
      right: 0;
    }
  }
}
</style>
